<template lang="pug">
CommonDialog(v-model="visible", @touchmove.prevent :opacity="'0.7'")
  .wanliu-body
    img.banner(
      src="https://m.hellobike.com/resource/helloyun/07177/W1g-AabYZq.png"
    )
    .body
      .title {{ title }}
      .subtitle(v-if="!timeout") {{ subtitle }}
      .countdown(v-else)
        span.time-unit {{ h }}
        span.seperator &nbsp;:&nbsp;
        span.time-unit {{ m }}
        span.seperator &nbsp;:&nbsp;
        span.time-unit {{ s }}
        span.suffix 后过期
      template(v-if="!info.isCard")
        .card-wrapper
          CardC(:info="info", :mode="4")
      template(v-else)
        .discount-wrapper
          .discount-wrapper-left
            .amount {{ info.finalPrice }}
            .unit 元
          .discount-wrapper-right
            .discount-title 限时专享购卡补贴
            .discount-subtitle 购卡立减
      .btns
        .left.btn.flex-mid(@click="cancel") 放弃优惠
        .right.btn.flex-mid(@click="buy") 立即购买
</template>

<script>
import CommonDialog from '@/components/common-modal';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { ParamsUtil } from '../../../../utils/params';
import { getTokenAndLocation } from '../../../../utils';
import CardC from './card-c.vue';

export default {
  components: {
    CommonDialog,
    CardC,
  },
  data() {
    return {
      visible: false,
      info: {
        isCard: true,
      },
      timer: null,
      title: '',
      timeout: 0,
      h: '',
      m: '',
      s: '',
      time: {
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
      subtitle: '',
    };
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    // info 卡、券对象
    // timeout 若需要展示倒计时，传秒
    // title 主标题
    // subtitle 副标题，展示倒计时时不展示
    open(options = {}) {
      const {
        info, timeout, title, subtitle,
      } = options;
      clearInterval(this.timer);
      if (options.info.expiredTime) {
        this.timeout = timeout;
        this.timer = setInterval(() => {
          if (this.timeout === 0) {
            clearInterval(this.timer);
            return;
          }
          this.showTime(this.timeout);
          this.timeout -= 1000;
        }, 1000);
      }
      Object.assign(this, {
        info,
        title,
        subtitle,
      });
      this.visible = true;
    },
    showTime(timeout) {
      // 后台给我的是10位 精确到秒的  所有下面我就除以了1000，不要小数点后面的
      // eslint-disable-next-line no-console
      if (timeout) {
        const t = timeout;
        // eslint-disable-next-line no-console
        // 如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
        let d = Math.floor(t / 60 / 60 / 24); // 天 var d=Math.floor(t/1000/60/60/24)
        // eslint-disable-next-line no-mixed-operators
        const h = Math.floor((t / 1000 / 60 / 60) % 24);
        // 时 var h=Math.floor(t/1000/60/60%24)
        // eslint-disable-next-line no-mixed-operators
        const m = Math.floor((t / 1000 / 60) % 60); // 分 var m=Math.floor(t/1000/60%60)
        // eslint-disable-next-line no-mixed-operators
        const s = Math.floor((t / 1000) % 60); // 秒 var s=Math.floor(t/1000%60)
        if (parseInt(d, 10) < 10) {
          d = `0${d}`;
        }
        if (parseInt(h, 10) < 10) {
          this.h = `0${h}`;
        } else {
          this.h = `${h}`;
        }
        if (parseInt(m, 10) < 10) {
          this.m = `0${m}`;
        } else {
          this.m = `${m}`;
        }
        if (parseInt(s, 10) < 10) {
          this.s = `0${s}`;
        } else {
          this.s = `${s}`;
        }
      }
    },
    cancel() {
      this.visible = false;
      this.$emit('cancel', this.info);
    },
    async buy() {
      if (this.info.isCard) {
        UBT.clickButton({
          pageId: 'platform_appmarketing',
          buttonName: 'platform_Retaincardgo',
          categoryId: 'platform',
          businessInfo: {},
        });
        this.visible = false;
        this.$emit('cancelRight', this.info);
      } else {
        UBT.clickButton({
          pageId: 'platform_appmarketing',
          buttonName: 'platform_Retaincoupongo',
          categoryId: 'platform',
          businessInfo: {},
        });
        const { token, adCode, cityCode } = await getTokenAndLocation();
        window.location.href = ParamsUtil.addParams(this.info.buttonLink, {
          token,
          adCode,
          cityCode,
        });
      }
    },
    // eslint-disable-next-line consistent-return
    getMoney() {
      if (this.info) {
        let money = (this.info.originPrice - this.info.finalPrice).toFixed(2);
        if (money % 1 === 0) {
          money = Math.trunc(money);
        }
        return money;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wanliu-body {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 3rem;
  display: flex;
  flex-direction: column;
  z-index: 2;

  .banner {
    width: 100%;
    height: 1.08rem;
  }

  .body {
    background: #08f;
    height: 1.72rem;
    width: 3rem;
    padding: 0 0.16rem;
    border-radius: 0 0 0.12rem 0.12rem;
  }

  .title {
    font-size: 0.24rem;
    font-weight: 600;
    color: #fff;
    position: absolute;
    left: 0.21rem;
    top: 0.34rem;
  }

  .discount-wrapper {
    width: 2.68rem;
    height: 0.8rem;
    background: #fff;
    box-shadow: 0 0.04rem 0.08rem 0 rgba(188, 196, 204, 0.1);
    border-radius: 0.08rem;
    padding: 0.2rem 0.16rem 0 0.16rem;
    display: flex;

    .discount-wrapper-left {
      display: flex;

      .amount {
        font-size: 0.3rem;
        font-family: DINAlternate-Bold, DINAlternate, sans-serif;
        font-weight: bold;
        color: #fa4614;
        line-height: 0.35rem;
      }

      .unit {
        margin-left: 0.03rem;
        font-size: 0.14rem;
        font-weight: 600;
        color: #fa4614;
        line-height: 0.46rem;
      }
    }

    .discount-wrapper-right {
      margin-left: 0.17rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      .discount-title {
        font-size: 0.16rem;
        font-weight: 500;
        color: #242729;
        line-height: 0.22rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .discount-subtitle {
        font-size: 0.12rem;
        color: #879099;
        line-height: 0.17rem;
      }
    }
  }

  .subtitle {
    font-size: 0.14rem;
    font-weight: 500;
    color: #fff;
    position: absolute;
    left: 0.21rem;
    top: 0.74rem;
  }

  .countdown {
    font-size: 0.14rem;
    font-weight: 500;
    color: #fff;
    position: absolute;
    left: 0.21rem;
    top: 0.74rem;

    .suffix {
      margin-left: 0.04rem;
    }

    .time-unit {
      display: inline-block;
      width: 0.2rem;
      height: 0.2rem;
      background: white;
      font-size: 0.14rem;
      font-weight: 500;
      color: #08f;
      text-align: center;
      line-height: 0.2rem;
    }
  }

  .card-wrapper {
    width: 2.68rem;
    height: 0.96rem;
    background: #fff;
    box-shadow: 0 0.04rem 0.08rem 0 rgba(188, 196, 204, 0.1);
    border-radius: 0.08rem;
    padding: 0.12rem;
  }

  .btns {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 0.14rem;
    height: 0.8rem;

    .btn {
      width: 1.28rem;
      height: 0.48rem;
      border-radius: 0.08rem;
      font-size: 0.18rem;
    }

    .left {
      border: 0.01rem solid #fff;
      background: #08f;
      color: white;
    }

    .right {
      color: #08f;
      background: white;
    }
  }
}
</style>
